import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BzgModalService } from 'bz-genome-angular';
import { PackageDependenciesComponent } from '../package-dependencies/package-dependencies.component';

@Component({
  selector: 'biz-package-visualizer-list',
  templateUrl: './package-visualizer-list.component.html',
  styleUrls: ['./package-visualizer-list.component.scss']
})
export class PackageVisualizerListComponent implements OnInit, OnChanges {
  public filterText: { [key: string]: string } = {};
  public isExpandAll = false;
  public typeExpandedCatalogObject: { [key: string]: boolean } = {};
  @Input() searchText = '';
  @Input() catalogObjects: Array<{ type: string, objectList: ICatalogObject[] }>;
  @Input() isLoading;
  @Input() isSearchMode = false;

  @Output() onSelectCatalogObject: EventEmitter<string> = new EventEmitter<string>();

  constructor(private _modalService: BzgModalService, private _translateService: TranslateService) { }

  ngOnInit() {
    /* this.isLoading = !this.isSearchMode && (this.catalogfilterTextObjects === null || this.catalogObjects.length === 0); */
    // console.log("The select list of catalog objects is: ", this.catalogObjectList);
  }

  ngOnChanges() {
    if (this.catalogObjects)
      this.changeType();
  }

  changeType() {
    this.catalogObjects.forEach(catalogObj => {
      if (catalogObj.objectList)
        this.lookForStakeHolder(catalogObj.objectList);
      if (catalogObj.type.toLowerCase() === 'stakeholdersentencecontext')
        catalogObj.type = this._translateService.instant('TYPE.CONTEXT');
      if (catalogObj.type.toLowerCase() === 'stakeholder')
        catalogObj.type = this._translateService.instant('TYPE.PERSONA');
    });
  }

  lookForStakeHolder(catalogObj: any) {
    catalogObj.forEach(obj => {
      if (obj.name.toLowerCase() === 'stakeholdersentencecontext')
        obj.name = this._translateService.instant('TYPE.CONTEXT');
      if (obj.name.toLowerCase() === 'stakeholder')
        obj.name = this._translateService.instant('TYPE.PERSONA');
    });
  }

  toggleExpand(type: string) {
    this.typeExpandedCatalogObject[type] = this.typeExpandedCatalogObject[type] ? false : true;
  }

  navigateTo(catalogObject: ICatalogObject) {
    this.onSelectCatalogObject.emit(catalogObject.id);
  }

  toggleExpandAll() {
    this.isExpandAll = !this.isExpandAll;
    this.catalogObjects.forEach(({ type }) => {
      this.typeExpandedCatalogObject[type] = this.isExpandAll;
    });
  }

  openDependenciesModal(event: any, catalogObject: ICatalogObject) {
    event.stopPropagation();
    this._modalService.open(PackageDependenciesComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      height: 665,
      width: 956,
      maxWidth: 956,
      data: {
        catalogObjectId: catalogObject.id,
      }
    });
  }
}
